import { render } from "./addTargetDialog.vue?vue&type=template&id=50a9ce85&scoped=true"
import script from "./addTargetDialog.vue?vue&type=script&lang=js"
export * from "./addTargetDialog.vue?vue&type=script&lang=js"

import "./addTargetDialog.vue?vue&type=style&index=0&id=50a9ce85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a9ce85"]])

export default __exports__